import { FC, ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { useReportId, useRtl } from "@ryde/redux";
import {
  getReportFooterValue,
  IReportApiDto,
  IReportGridColumn,
  reportTableRowsAF,
  useTimezone,
} from "@ryde/shared";

interface ICellFooterSummary {
  reportDto?: IReportApiDto;
  columnFooterPrefix?: string;
  prefixTotalDelimiter?: ReactNode;
  reportGridColumn: IReportGridColumn;
}

export const CellFooterSummary: FC<ICellFooterSummary> = ({
  reportDto,
  columnFooterPrefix,
  prefixTotalDelimiter,
  reportGridColumn,
}) => {
  const { timezone } = useTimezone();
  const { t } = useTranslation();
  const { isRtl } = useRtl();
  const { reportId } = useReportId();
  const rows = useRecoilValue(reportTableRowsAF(reportId));
  const reportFooterValue = useMemo(() => {
    return getReportFooterValue({
      rows,
      reportGridColumn,
      timezone,
      t,
    });
  }, [reportGridColumn, rows, t, timezone]);
  const IsForceLtr = columnFooterPrefix === "%";
  return (
    reportDto && (
      <span>
        {!isRtl && !IsForceLtr && (
          <>
            {columnFooterPrefix}
            {Boolean(prefixTotalDelimiter) && prefixTotalDelimiter}
          </>
        )}
        {reportFooterValue !== undefined && reportFooterValue}
        {(isRtl || IsForceLtr) && (
          <>
            {Boolean(prefixTotalDelimiter) && prefixTotalDelimiter}
            {columnFooterPrefix}
          </>
        )}
      </span>
    )
  );
};
